console.log("hello from index.js");

import "./scss/global.scss";
import "./js/scripts.js";
